<template>
  <div id="employees">
    <PageTitle title="Medewerkers" description="Alle medewerkers die toegang hebben tot de app"></PageTitle>
    <div class="searchbar">
      <router-link to="new-employee/new" class="btn btn-success btn-lg mb-3">+ medewerker toevoegen</router-link>

      <div class=" d-flex justify-content-between">
        <div class=" ">
          <input type="text" class="form-control" placeholder="zoeken" v-model="search" />
        </div>
        <div class="">
          <span for="establisment" class="form-label " >toon vestiging </span>

          <select
            name="establisment"
            v-model="selectedEstablishment"
            @change="filterEstablishment($event)"
          >
            <option value="Alle vestigingen" selected>Alle vestigingen</option>
            <option v-for="(est) in establishments" :key="est.name" :value="est.name">{{est.name}}</option>
          </select>
        </div>
      </div>
    </div>
    <div id="employee-table" v-if="employees.length">
      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th></th>
            <th>voornaam</th>
            <th>achternaam</th>
            <th>email</th>
            <th>telefoon</th>
            <th>vestiging</th>
            <!-- <th>functie(s)</th>
            <th>vestiging(en)</th>-->
            <th>acties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user) in filteredItems" :key="user.id">
            <td>
              <img v-if="user.avatar.url != ''" :src="user.avatar.url" class="avatar" />
            </td>
            <td>{{user.firstname}}</td>
            <td>{{user.lastname}}</td>
            <td>{{user.email}}</td>
            <td>{{user.phonenumber}}</td>
            <td>{{user.establishmentname }}</td>
            <!--<td>todo</td>-->
            <td>
              <router-link class :to=" { name: 'new-employee', params: {id: user.id} }">
                <Icon icon="pencil" title="aanpassen" success></Icon>
              </router-link>
              <Icon icon="trash" title="verwijder" v-on:clicked="deleteUser(user)" danger></Icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!employees | !employees.length">Er zijn geen gebruikers.</div>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");

import { mapState } from "vuex";
import PageTitle from "@/components/PageTitle.vue";
import Icon from "@/components/icon.vue";

export default {
  name: "employees",
  components: {
    PageTitle,
    Icon
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),

    filteredItems() {
      return this.filterdEmployees.filter(item => {
        var firstn, lastn, ema;
        firstn =
          item.firstname.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1 ?? "";
        lastn =
          item.lastname.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ??
          "";
        ema = item.email
          ? item.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          : false;
        return firstn || lastn || ema;
      });
    }
  },
  data() {
    return {
      search: "",
      employees: [],
      filterdEmployees: [],
      establishments: [],
      selectedEstablishment: "Alle vestigingen"
    };
  },
  methods: {
    filterEstablishment(payload) {
      console.log(payload.target);
      console.log(payload.target.value);
      this.selectedEstablishment = payload.target.value;
      if (this.selectedEstablishment != "Alle vestigingen") {
        this.filterdEmployees = [];
        this.employees.forEach(item => {
          if (item.establishmentname == this.selectedEstablishment)
            this.filterdEmployees.push(item);
        });
      } else {
        this.filterdEmployees = this.employees;
      }
    },

    deleteUser(u) {
      this.$confirm({
        message:
          "Medewerker " + u.firstname + " " + u.lastname + " verwijderen?",
        button: {
          no: "annuleren",
          yes: "verwijderen"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            var th = this;
            fb.usersCollection
              .doc(u.id)
              .delete()
              .then(function() {
                console.log("medewerker verwijderd");
                th.$router.go();
              })
              .catch(function(error) {
                console.log("Error deleting: ", error);
              });
          }
        }
      });
    }
  },
  created() {
    fb.companiesCollection
      .doc(this.$cookies.get("company"))
      .collection("establishments")
      .orderBy("name")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.id,
            address: doc.data().address,
            city: doc.data().city,
            phonenumber: doc.data().phonenumber,
            zipcode: doc.data().zipcode,
            name: doc.data().name,
            hq: doc.data().hq,
            image: {
              url: doc.data().image
                ? doc.data().image["url"]
                : "https://via.placeholder.com/300x200?text=Upload+een+foto",
              filename: doc.data().image ? doc.data().image["filename"] : ""
            }
          };
          this.establishments.push(data);
        });
      });

    fb.usersCollection
      .orderBy("lastname", "asc")
      .where("company", "==", this.$cookies.get("company"))
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          // console.log(doc.id);
          const data = doc.data();
          // {
          //   id: doc.id,
          //   firstname: doc.data().firstname,
          //   lastname: doc.data().lastname,
          //   roles: doc.data().roles,
          //   email: doc.data().email,
          //   phonenumber: doc.data().phonenumber,
          // };
          data.id = doc.id;
          if (!data.avatar)
            data.avatar = {
              url: ""
            };

          // vestiging
          if (data.establishments && data.establishments.length > 0) {
            // console.log("vestiging id: " + data.establishments[0])
            this.establishments.forEach(est => {
              if (est.id == data.establishments[0]) {
                data.establishmentname = est.name;
              }
            });
          }

          this.employees.push(data);
        });
        this.filterdEmployees = this.employees;
      });
  }
};
</script>

<style scoped>
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>